import { FieldValues } from "react-hook-form";

import { getTranslationLabelLanguage } from "../helpers/loadTranslationLabels";
import { useTranslationLocales } from "../Context/TranslationLocaleContext";

import { TranslationEditorField } from "./TranslationEditorField";

import { useTranslate } from "@/common/hooks/useTranslate";
import { OutlinedTextFieldWysiwyg } from "@/components/OutlinedTextFieldWysiwyg/OutlinedTextFieldWysiwyg";
import { OutlinedTextFieldWysiwygProps } from "@/components/OutlinedTextFieldWysiwyg/type";

type TranslationFieldWysiwygProps<T extends FieldValues> = Omit<OutlinedTextFieldWysiwygProps<T>, "id"> & {
  id?: string;
};

export function TranslationFieldWysiwyg<T extends FieldValues>({ id, ...props }: TranslationFieldWysiwygProps<T>) {
  const { t } = useTranslate();
  const locales = useTranslationLocales();
  const label = t(
    "dashboard",
    props.name.endsWith(".description") ? "translation.campaignDescription" : "translation.emailContent",
    {
      lng: getTranslationLabelLanguage(locales?.formLocale),
    }
  );

  return (
    <TranslationEditorField label={label} name={id ?? props.name}>
      <OutlinedTextFieldWysiwyg
        {...props}
        compact
        compactEmailActions={props.name.endsWith(".emailContent") ? "menu" : "toolbar"}
        height={props.name.endsWith(".emailContent") ? 197 : undefined}
        id={id ?? props.name}
        keyName={props.keyName ?? `mailFieldWysiwyg-${props.name}`}
      />
    </TranslationEditorField>
  );
}
